import React, { useCallback } from "react";
import { SpaceProps } from "styled-system";
import { Box } from "../../../../Box";
import { ContactDetailFields } from "../../../ContactDetailFields";
import { ContactConfig } from "../../../../../types/ContactConfig";
import { NewContactPreferences } from "../NewContactPreferences";
import { ContactDetails } from "../../../../../types/ContactDetailsValues";
import { BillingAddressSection } from "../../../../BillingAddressSection";
import { useFormikContext } from "formik";

interface Props {
  idPrefix: string;
  namePrefix: string;
  contactConfig: ContactConfig;
  contactDetails: ContactDetails;
}

export const NewContactDetails: React.FC<Props & SpaceProps> = ({
  idPrefix,
  namePrefix,
  contactConfig,
  contactDetails,
}) => {
  const { setFieldValue } = useFormikContext();
  const handleActionLinkClick = useCallback(() => {
    setFieldValue(
      `${namePrefix}.manuallyEnteredBillingAddress`,
      !contactDetails.manuallyEnteredBillingAddress,
    );
  }, [setFieldValue, contactDetails.manuallyEnteredBillingAddress, namePrefix]);

  return (
    <Box id={idPrefix} mt={3} mb={3}>
      <ContactDetailFields
        idPrefix={idPrefix}
        namePrefix={namePrefix}
        optionalFirstName={contactConfig.fieldsConfig.optionalFirstName}
        optionalLastName={contactConfig.fieldsConfig.optionalLastName}
        optionalEmail={contactConfig.fieldsConfig.optionalEmail}
        optionalMobile={contactConfig.fieldsConfig.optionalMobile}
        optionalAlternatePhone={
          contactConfig.fieldsConfig.optionalAlternatePhone
        }
        optionalBusinessName={contactConfig.fieldsConfig.optionalBusinessName}
        showEmail={contactConfig.fieldsConfig.showEmail}
        showPhone={contactConfig.fieldsConfig.showPhone}
        showBusinessName={contactConfig.fieldsConfig.showBusinessName}
        disabledFirstName={contactConfig.fieldsConfig.disabledFirstName}
        disabledLastName={contactConfig.fieldsConfig.disabledLastName}
        disabledEmail={contactConfig.fieldsConfig.disabledEmail}
        disabledMobile={contactConfig.fieldsConfig.disabledMobile}
        disabledAlternatePhone={
          contactConfig.fieldsConfig.disabledAlternatePhone
        }
        disabledBusinessName={contactConfig.fieldsConfig.disabledBusinessName}
      />

      {contactConfig.fieldsConfig.showBusinessAddress && (
        <BillingAddressSection
          fieldIdPrefix={idPrefix}
          fieldNamePrefix={namePrefix}
          isManualAddress={contactDetails.manuallyEnteredBillingAddress}
          shouldDisableContactDetails={
            contactConfig.fieldsConfig.disableBusinessAddress
          }
          handleActionLinkClick={handleActionLinkClick}
        />
      )}

      <NewContactPreferences
        idPrefix={idPrefix}
        namePrefix={namePrefix}
        contactPreferencesConfig={contactConfig.preferencesConfig}
        contactDetails={contactDetails}
      />
    </Box>
  );
};
